import styled from 'styled-components';

import { fadeIn, fadeOut, slideInAndFade, slideOutAndFade } from './animations';

type ContainerProps = {
  animated: boolean;
};

export const Content = styled.div`
  background-color: #ffffff;
  overflow: hidden;
`;

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  z-index: 9999999;
  overflow: hidden;

  &.visible {
    visibility: visible;
    background-color: rgba(0, 0, 0, 0.5);
    animation: 0.2s linear ${fadeIn};

    ${Content} {
      transform: ${({ animated }) => (animated ? 'translateY(0px)' : 'none')};
      opacity: 1;
      animation: 0.3s ease-out ${slideInAndFade};
    }
  }

  &.hidden {
    background-color: rgba(0, 0, 0, 0);
    visibility: hidden;
    animation: 0.2s linear ${fadeOut};

    ${Content} {
      transform: ${({ animated }) => (animated ? 'translateY(-20px)' : 'none')};
      opacity: 0;
      animation: 0.3s ease-out ${slideOutAndFade};
    }
  }
`;
